module.exports = __webpack_public_path__ + "static/europa_logo-d42ca3b85b1e871ac0a6869b62a7d9b9.png";